import { useEffect, useState } from 'react'
import { Alert, Spin } from 'antd'
import { onSessionExpired } from '../api/sessionBus.ts'

// Banner shown when an API call returns 401 (token expired or revoked). The
// response handler redirects to /auth/login after a short delay; this just tells
// the user why they are about to be sent back to sign in, so the redirect is not
// silent.
export const SessionExpiredNotice = () => {
    const [visible, setVisible] = useState(false)

    useEffect(() => onSessionExpired(() => setVisible(true)), [])

    if (!visible) return null

    return (
        <Alert
            type="info"
            showIcon
            icon={<Spin size="small" />}
            message="Your session has ended"
            description="Your sign-in expired or was revoked. Taking you back to sign in…"
            style={{
                position: 'fixed',
                top: 12,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 2000,
                maxWidth: 560,
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            }}
        />
    )
}
